import React, { useReducer } from 'react';
import ApparelContext from './apparelContext';
import ApparelReducer from './apparelReducer';

const ApparelState = (props) => {
  const initialState = {
    collections: [
      {
        id: 1,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
      {
        id: 2,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
      {
        id: 3,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
      {
        id: 4,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
      {
        id: 5,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
      {
        id: 6,
        // img: '',
        heading: 'Collection 1',
        para: 'Line 1',
      },
    ],
    tees: [
      {
        id: 1,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 2,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 3,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 4,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 5,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 6,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 7,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 8,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 9,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 10,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 11,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 12,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 13,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 14,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 15,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 16,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
    ],
    products: [
      {
        id: 13,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 14,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 15,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
      {
        id: 16,
        heading: 'Bene Rohlmann Mens T-Shirt',
        price: '1,895',
      },
    ],
  };
  const [state] = useReducer(ApparelReducer, initialState);

  return (
    <ApparelContext.Provider
      value={{
        collections: state.collections,
        tees: state.tees,
        products: state.products,
      }}
    >
      {props.children}
    </ApparelContext.Provider>
  );
};

export default ApparelState;
